import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { Box, Typography, styled } from "@mui/material";
import React from "react";
import { useTranslation } from "@localization/useTranslation";

export type ManagementReportVariant = "audit" | "internalAssessment";

export interface ManagementReportDescriptionProps {
    scoreEnabled: boolean;
    auditName: string;
    variant: ManagementReportVariant;
}

const DescriptionText = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(16),
}));

// The two reports describe the same thing to different audiences - one is about respondents in an audit group,
// the other about recipients of an internal assessment - so only the wording differs between them.
const descriptionKeys: Record<ManagementReportVariant, { withScore: string; withoutScore: string }> = {
    audit: {
        withScore: "managementReportDescriptionWithScore",
        withoutScore: "managementReportDescriptionWithoutScore",
    },
    internalAssessment: {
        withScore: "internalAssessmentManagementReportDescriptionWithScore",
        withoutScore: "internalAssessmentManagementReportDescriptionWithoutScore",
    },
};

function ManagementReportDescription(props: ManagementReportDescriptionProps) {
    const { translateString } = useTranslation();
    const keys = descriptionKeys[props.variant];

    return (
        <Box>
            <DotLegalHeader headerStyle="xxxl">{translateString("managementReportHeader", { auditName: props.auditName })}</DotLegalHeader>

            <DescriptionText>{translateString(props.scoreEnabled ? keys.withScore : keys.withoutScore)}</DescriptionText>

            <DescriptionText sx={(theme) => ({ fontStyle: "italic", marginTop: 3, fontSize: theme.typography.pxToRem(14) })}>
                {translateString("managementReportDescriptionNotLawFirm")}
            </DescriptionText>
        </Box>
    );
}

export default ManagementReportDescription;
